export const institucionTypes = {
    INSTITUCION_RESET: '[Institucion] RESET',
    INSTITUCION_GET_START: '[Institucion] GET_START',
    INSTITUCION_GET_COMPLETE: '[Institucion] GET_COMPLETE',
    INSTITUCION_GET_ERROR: '[Institucion] GET_ERROR'  
}